import { BooleanInput } from '@angular/cdk/coercion';
import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, effect, inject, Input, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { RouterLink } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { Role } from 'app/shared/enums/role';
import { PermissionType } from 'app/shared/enums/permission-type';
import { PermissionsService } from 'app/shared/services/permissions.service';
import { UserStore } from 'app/modules/users/store/user.store';
import { User } from 'app/shared/types/user.types';
import { UserDialogComponent } from 'app/modules/users/user-dialog/user-dialog.component';
import { ButtonComponent } from 'app/layout/common/button/button.component';
import { MatDialogService } from 'app/shared/services/material/mat-dialog.service';
import { MatSnackBarService } from 'app/shared/services/material/mat-snack-bar.service';
import { buildInfo } from 'environments/build-info';

@Component({
    selector: 'user',
    templateUrl: './user.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'user',
    standalone: true,
    imports: [
        MatButtonModule,
        MatMenuModule,
        MatIconModule,
        NgClass,
        MatDividerModule,
        RouterLink,
        ButtonComponent
    ]
})
export class UserComponent {
    private _dialogService = inject(MatDialogService);
    private _userStore = inject(UserStore);
    private _authService = inject(AuthService);
    private _changeDetectorRef = inject(ChangeDetectorRef);
    private _snackBarService = inject(MatSnackBarService);

    static ngAcceptInputType_showAvatar: BooleanInput;

    @Input() showAvatar: boolean = true;
    user: User | undefined;
    permissionsService = inject(PermissionsService);
    role = Role;
    permissionType = PermissionType;
    readonly buildInfo = buildInfo;

    constructor() {
        effect(() => {
            this.user = this._userStore.user()!;
            this._changeDetectorRef.markForCheck();
        });
    }

    signOut(): void {
        this._authService.signOut();
    }

    userProfile(): void {
        this._dialogService.open(UserDialogComponent, {}, 500);
    }

    copyBuildVersion(event: MouseEvent): void {
        event.stopPropagation();
        void navigator.clipboard.writeText(this.buildInfo.buildNumber).then(() => {
            this._snackBarService.open('Version copied', 2000, 'fill', 'success');
        });
    }
}
